/**
 * Walking speed from the boots (ADR 0059): a fixed substat that every pair
 * carries, read from its template alone — rarity and required level — so
 * neither the smith's +N nor an affix changes it. A cosmetic gives nothing,
 * like everything else it could say (ADR 0031).
 */
/** Whole percent a pair of each rarity gives at level 0, before its level. */
export const BOOTS_SPEED_BY_RARITY = {
    common: 3,
    rare: 5,
    epic: 7,
    legendary: 10,
};
/**
 * Percent added per required level, rounded to a whole percent: the meadow's
 * common clogs give 3 %, the peaks' legendary boots 15 %, Shefira's legendary
 * greaves (level 20, ADR 0068) 16 % at most — well short of the slowest mount
 * (×1.6), so boots never replace one.
 */
export const BOOTS_SPEED_PER_LEVEL = 0.3;
/** Whole percent of walking speed a template gives: boots only, never a cosmetic. */
export function bootsSpeedBonus(template) {
    if (template.slot !== 'boots' || template.cosmetic)
        return 0;
    return (BOOTS_SPEED_BY_RARITY[template.rarity] +
        Math.round(template.levelRequired * BOOTS_SPEED_PER_LEVEL));
}
/** The worn boots' bonus, in whole percent; 0 barefoot. The cosmetic place over them does not count. */
export function gearSpeedBonus(equipped, templateOf) {
    const templateId = equipped.boots?.templateId;
    const template = templateId === undefined ? undefined : templateOf(templateId);
    return template === undefined ? 0 : bootsSpeedBonus(template);
}
/**
 * The multiplier a walker's pace is divided by: the mount's (1 on foot)
 * times the boots'. Boots count in the saddle too, so they are never taken
 * off to ride. The server and the client's prediction both compute it from
 * the same two numbers, the bonus travelling as a whole percent.
 */
export function walkSpeedMultiplier(mountMultiplier, speedBonus) {
    return mountMultiplier * (1 + speedBonus / 100);
}
//# sourceMappingURL=speed.js.map